/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
const AFRAME = window.AFRAME;
const THREE = window.THREE;

if (!AFRAME.components["watch-me"])
    AFRAME.registerComponent("watch-me", {
        init: function () {
            const cameraPosition = document
                .querySelector("a-camera")
                .getAttribute("position");
            this.el.object3D.lookAt(
                new THREE.Vector3(
                    cameraPosition.x,
                    cameraPosition.y,
                    cameraPosition.z
                )
            );
        }
    });
